export const translations = {
  de: {
    appName: "klinik-begleiter24",
    tagline: "Niemand sollte allein zum Arzt mussen.",
    name: "Name",
    email: "E-Mail",
    password: "Passwort",
    iAm: "Ich bin...",
    patient: "Patient (suche Begleitung)",
    individual: "Einzelperson (biete Begleitung an)",
    agency: "Agentur / Unternehmen",
    register: "Registrieren",
    login: "Anmelden",
    alreadyRegistered: "Bereits registriert?",
    noAccount: "Noch kein Konto?",
    welcome: "Willkommen",
    logout: "Abmelden",
    home: "Home",
    search: "Suche",
    bookings: "Buchungen",
    profile: "Profil",
    booked: "Gebucht",
    confirmed: "Bestatigt",
    completed: "Abgeschlossen",
    overview: "UBERSICHT",
    bookedAppointments: "Gebuchte Termine",
    confirmedAppointments: "Bestatigte Termine",
    profileStatus: "Profilstatus",
    findCompanion: "Begleitung suchen",
    incompleteProfile: "Profil unvollstandig",
    completeProfilePrompt: "Bitte vervollstandigen Sie Ihr Profil, um Termine zu buchen.",
    insuranceNumber: "Krankenversicherungsnummer",
    mobileNumber: "Mobilnummer",
    saveProfile: "Profil speichern",
    saving: "Speichern...",
    photoOneTime: "Das Profilfoto kann nur einmal hochgeladen werden.",
    photoLocked: "Foto gesperrt. Anderungen nur uber den Support mit Nachweis.",
    noPhoto: "Kein Foto",
    noBookedAppointments: "Noch keine gebuchten Termine.",
    noConfirmedAppointments: "Noch keine bestatigten Termine.",
    noCompletedAppointments: "Noch keine abgeschlossenen Termine.",
    allTypes: "Alle Typen",
    allStates: "Alle Bundeslander",
    allCities: "Alle Stadte",
    noProvidersFound: "Keine Begleitpersonen gefunden.",
    request: "Anfragen",
    loading: "Laden...",
  },
  en: {
    appName: "klinik-begleiter24",
    tagline: "No one should have to go to the doctor alone.",
    name: "Name",
    email: "Email",
    password: "Password",
    iAm: "I am...",
    patient: "Patient (looking for a companion)",
    individual: "Individual (offering companionship)",
    agency: "Agency / Company",
    register: "Register",
    login: "Log In",
    alreadyRegistered: "Already registered?",
    noAccount: "No account yet?",
    welcome: "Welcome",
    logout: "Log Out",
    home: "Home",
    search: "Search",
    bookings: "Bookings",
    profile: "Profile",
    booked: "Booked",
    confirmed: "Confirmed",
    completed: "Completed",
    overview: "OVERVIEW",
    bookedAppointments: "Booked Appointments",
    confirmedAppointments: "Confirmed Appointments",
    profileStatus: "Profile Status",
    findCompanion: "Find a Companion",
    incompleteProfile: "Incomplete Profile",
    completeProfilePrompt: "Please complete your profile to book appointments.",
    insuranceNumber: "Health Insurance Number",
    mobileNumber: "Mobile Number",
    saveProfile: "Save Profile",
    saving: "Saving...",
    photoOneTime: "The profile photo can only be uploaded once.",
    photoLocked: "Photo locked. Changes only via support with proof.",
    noPhoto: "No Photo",
    noBookedAppointments: "No booked appointments yet.",
    noConfirmedAppointments: "No confirmed appointments yet.",
    noCompletedAppointments: "No completed appointments yet.",
    allTypes: "All Types",
    allStates: "All States",
    allCities: "All Cities",
    noProvidersFound: "No companions found.",
    request: "Request",
    loading: "Loading...",
  },
};
